module.exports = __webpack_public_path__ + "static/media/2014 - 15 Shirley Tam-min.2bd81c02.jpg";